import React, {PropsWithChildren} from "react";
import {useField} from "formik";
import FormFieldError from "./FormFieldError";
import {useSelector} from "react-redux";
import {RootState} from "../store";

interface CheckboxesFieldGroupPropsI {
    name: string
}

const CheckboxesFieldGroup: React.FC<PropsWithChildren<CheckboxesFieldGroupPropsI>> = (props) => {

    const [_, meta] = useField(props.name);

    const checkboxesFieldGroupCaption = useSelector((state: RootState) => state.storeLocatorSettingsSlice.productTypesFieldGroupCaption);

    return (
        <div className="blj-store-locator-field-group">
            {checkboxesFieldGroupCaption.length > 0 && (
                <span className="blj-store-locator-field-group__caption">
                    {checkboxesFieldGroupCaption}
                </span>
            )}
            {props.children}

            {meta.touched && meta.error && (
                <FormFieldError errorMessage={meta.error}/>
            )}
        </div>
    );
}

export default CheckboxesFieldGroup;